import { useState } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { Button } from "@progress/kendo-react-buttons";
import { FormattedMessage } from "react-intl";

export interface CreateModalProps {
  description: string;
  successText: string;
  onSuccess: (e: string) => void;
  onCancel: () => void;
  data: ListItem[];
}

export interface ListItem {
  icon: string;
  iconDescription: string;
  disabled?: boolean;
}

export function CreateModal(props: CreateModalProps) {
  const [select, setSelect] = useState<string>();

  return (
    <Dialog>
      <div className="w-full h-full rounded-lg flex px-2 flex-col space-x-3 justify-around items-center">
        <div className="w-full flex items-end justify-end">
          {" "}
          <div
            onClick={() => props.onCancel()}
            // className="rounded-full hover:cursor-pointer bg-mk-primary-50"
            className="pt-1 pb-1 pl-2 pr-2 rounded-full hover:cursor-pointer bg-mk-primary-50 mr-1"
          >
            <FontAwesomeIcon
              icon={["far", "fa-xmark" as IconName]}
              // className="lg:px-1.5 lg:py-1 px-1 py-0.5"
              className="w-3 h-3"
            />
          </div>{" "}
        </div>
        <div className="lg:text-xl sm:text-sm  text-black font-bold w-full ps-2">
          {props.description}
        </div>
        <div
          className="grid grid-cols-1 gap-y-6 py-5 overflow-y-auto lg:grid-cols-2 w-full lg:h-5/6 h-4/6 justify-center place-items-center
                                lg:gap-x-10 lg:gap-y-10 lg:py-10"
        >
          {/* {props.data.map((ele, index) => (
                        <div key={index} onClick={() => setSelect(ele.iconDescription)} className={`flex items-center lg:h-32 space-x-2 lg:w-80 sm:w-44 sm:h-20 sm:ps-2 sm:rounded-2xl border-2 border-mk-grey lg:rounded-3xl hover:cursor-pointer pe-3 pt-3 pb-3 hover:bg-mk-primary-20 ${ele.iconDescription === select ? "bg-mk-primary-20" : ""}`}>
                            <img src={ele.icon} alt="icon1" className='lg:ps-4 ps-1 lg:h-auto lg:w-auto w-16 h-12' />
                            <div className='lg:text-base text-sm font-bold text-black'>{ele.iconDescription}</div>
                        </div>
                    ))} */}

          {props.data.map((ele, index) => {
            const isSelected = ele.iconDescription === select;
            const isDisabled = ele.disabled;

            return (
              <div
                key={index}
                onClick={() => {
                  if (!isDisabled) setSelect(ele.iconDescription);
                }}
                className={`flex items-center lg:h-32 space-x-2 lg:w-80 sm:w-44 sm:h-20 sm:ps-2 sm:rounded-2xl border-2 
  ${isSelected ? "border-mk-grey bg-mk-primary-20" : "border-mk-grey"} 
  ${
    isDisabled
      ? "opacity-50 cursor-not-allowed"
      : "hover:cursor-pointer hover:bg-mk-primary-20"
  } 
  pe-3 pt-3 pb-3 lg:rounded-3xl`}
              >
                <img
                  src={ele.icon}
                  alt="icon"
                  className="lg:ps-4 ps-1 lg:h-auto lg:w-auto w-16 h-12"
                />
                <div className="lg:text-base text-sm font-bold text-black">
                  {ele.iconDescription}
                  {isDisabled && (
                    <span className="text-mk-grey-500 ms-2">
                      <FormattedMessage id="comingSoon" />
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div className="w-full pe-4 pb-4 flex justify-end">
          <Button
            className="lg:w-auto lg:h-auto lg:text-sm sm:text-[12px] sm:w-24 sm:h-8 "
            themeColor={"primary"}
            onClick={() => {
              if (select !== undefined) {
                props.onSuccess(select);
              }
            }}
          >
            {props.successText}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
